import { InlineFormProps } from './InlineForm.decl';
import { InlineFormButtons } from './InlineFormButtons';

import { Box, Flex, Form } from '@aircall/tractor';
import { Form as RFForm } from 'react-final-form';

export function InlineForm<FormValues, InitialFormValues>({
  formProps,
  children,
  onCloseClick,
  submitButtonText,
  shouldBlockNavigation,
  'data-test': dataTest,
  ...otherFlexProps
}: InlineFormProps<FormValues, InitialFormValues>) {
  const { onSubmit, ...rest } = formProps;

  return (
    <RFForm<FormValues, InitialFormValues>
      {...rest}
      onSubmit={async (values, form, callback) => {
        await onSubmit(values, form, callback);
        onCloseClick();
      }}
    >
      {(formRenderProps) => {
        const { handleSubmit, pristine, submitting } = formRenderProps;
        const shouldDisableSubmit = submitting || pristine;

        return (
          <Form onSubmit={handleSubmit} data-test={dataTest || 'inline-form'}>
            <Flex p='s' justifyContent='space-between' {...otherFlexProps}>
              <Flex width='100%'>{children(formRenderProps)}</Flex>
              <Box ml='s'>
                <InlineFormButtons
                  submitting={submitting}
                  onCloseClick={onCloseClick}
                  shouldDisableSubmit={shouldDisableSubmit}
                  handleSubmit={handleSubmit}
                  formRenderProps={formRenderProps}
                  submitButtonText={submitButtonText}
                  shouldBlockNavigation={shouldBlockNavigation}
                />
              </Box>
            </Flex>
          </Form>
        );
      }}
    </RFForm>
  );
}
